var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-award-audit',{staticClass:"pt-award-audit__page",attrs:{"business-type":_vm.businessType}})}
var staticRenderFns = []

export { render, staticRenderFns }